/**
 * Маркер захода на сайт из ВК. У ВК нет миниаппа, поэтому кнопки бота ведут на
 * веб-форму сайта со ссылкой вида `/release?audioId=123&from=vk` — по маркеру
 * фронт сам стартует VK ID OAuth, чтобы пользователь не искал вход руками.
 *
 * Маркер ОДНОРАЗОВЫЙ: сразу после обработки он вычищается из URL и помечается
 * в sessionStorage. Иначе отказ в OAuth (или закрытый попап) на перезагрузке
 * снова открывал бы окно входа — бесконечная петля.
 */
const ENTRY_PARAM = "from";
const ENTRY_VALUE = "vk";
/** Идентификатор юзера ВК, если бот его передал — в приложении не нужен. */
const ENTRY_EXTRA_PARAMS = ["vk_user_id"];
const CONSUMED_KEY = "tp_vk_entry_consumed";
const RETURN_PATH_KEY = "tp_vk_entry_return";
export function hasVkEntryMarker(search) {
    try {
        return new URLSearchParams(search).get(ENTRY_PARAM) === ENTRY_VALUE;
    }
    catch {
        return false;
    }
}
export function isVkEntryConsumed() {
    try {
        return sessionStorage.getItem(CONSUMED_KEY) === "1";
    }
    catch {
        // Приватный режим — считаем непотреблённым: URL всё равно чистим ниже,
        // так что повторов не будет в пределах этой навигации.
        return false;
    }
}
export function markVkEntryConsumed() {
    try {
        sessionStorage.setItem(CONSUMED_KEY, "1");
    }
    catch {
        /* private mode / quota */
    }
}
/**
 * Запомнить целевой роут перед полностраничным редиректом на VK ID.
 *
 * Бэк после OAuth-callback возвращает на КОРЕНЬ сайта (`/?auth=success`, см.
 * `auth/vk.py::_build_redirect_url`) — вернуть пользователя на форму релиза с
 * нужным `audioId` может только фронт.
 */
export function saveVkEntryReturnPath(path) {
    try {
        sessionStorage.setItem(RETURN_PATH_KEY, path);
    }
    catch {
        /* private mode / quota */
    }
}
/**
 * Забрать (и снять) сохранённый целевой роут. Принимаем только относительный
 * путь своего сайта — чтобы возврат нельзя было увести на чужой домен.
 */
export function takeVkEntryReturnPath() {
    let path = null;
    try {
        path = sessionStorage.getItem(RETURN_PATH_KEY);
        sessionStorage.removeItem(RETURN_PATH_KEY);
    }
    catch {
        return null;
    }
    if (!path || !path.startsWith("/") || path.startsWith("//")) {
        return null;
    }
    return path;
}
/** Тот же query без маркера ВК (остальные параметры — audioId, utm — сохраняем). */
export function stripVkEntryParams(search) {
    try {
        const params = new URLSearchParams(search);
        params.delete(ENTRY_PARAM);
        ENTRY_EXTRA_PARAMS.forEach((key) => params.delete(key));
        const query = params.toString();
        return query ? `?${query}` : "";
    }
    catch {
        return search;
    }
}
